import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
  standalone: false,
})
@Injectable({ providedIn: 'root' })
export class CustomCurrencyPipe implements PipeTransform {
  private currencyFormatter: Intl.NumberFormat;
  private FRACTION_SIZE = 2;
  private numberPattern = /^(-\d+|\d+)?([,.]\d+)?$/;

  constructor() {
    this.currencyFormatter = new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: this.FRACTION_SIZE,
    });
  }

  /**
   * user input to formatted currency
   */
  transform(value: string | number): string {
    if (value == undefined) {
      return;
    }

    let amount;
    if (typeof value === 'number') {
      amount = value;
    } else {
      amount = this.sekToNumber(value);
      if (!amount) {
        return value;
      }
    }

    const result = this.currencyFormatter
      .format(Math.abs(amount))
      .replaceAll('\u00A0', ' ');
    return amount < 0 ? `-${result}` : result;
  }

  parseSek(value: string): string {
    return value.replaceAll(/\s/g, ''); // ta bort spaces;
  }

  numberToSekStr(value: string): string {
    if (value) {
      return value.replace('.', ',');
    }
  }

  sekToNumber(amount: string): number {
    if (!this.numberPattern.test(amount)) {
      return;
    }

    const input = amount
      .replaceAll(/\s/g, '') // ta bort spaces
      .replace(',', '.'); // ändra decimal tecken

    if (!input || Number.isNaN(input as never)) {
      return;
    }
    return Number(Number.parseFloat(input).toFixed(this.FRACTION_SIZE));
  }
}
